<template>
	<label class="radio-checkbox-label radio-inline col-xs-12 pr-0">
		<input class="checkbox" type="radio" :checked="isSelected" />
		<span class="checkbox-custom" >
			<span v-if="isSelected && isActive" class="checkbox-dot" />
			<span v-else-if="isSelected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
		</span>
		<span style="font-weight: bold;" class="ml-3">{{ label }}</span>
		<img v-if="isActive"
			:src="imgSrc" style="height: 20px; position: relative; max-width: 55px;" class="pull-right" alt="checkout" />
		<span v-else class="pull-right" style="font-weight: bold;">Ändra</span>
	</label>
</template>

<script>
import { convertToCdnUrl } from 'utils';
export default {
	props:{
		isActive: {
			type: Boolean,
			required: true,
		},
		isStorePickup: {
			type: Boolean,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		isSelected: {
			type: Boolean,
		},
	},
	methods: {
		convertToCdnUrl,
	},
	computed: {
		imgSrc() {
			return this.isStorePickup ? convertToCdnUrl('/img/logos/wh_logo_blue.svg') : convertToCdnUrl('/img/checkout/kassa_skicka2.svg');
		},
	},
};
</script>
